import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function BlogCard({ post, index = 0 }) {
  const date = new Date(post.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`blog-card-${post.slug}`}
      className="group flex flex-col"
    >
      <Link to={`/blog/${post.slug}`} className="block overflow-hidden rounded-lg bg-[#f6f8f9] aspect-[16/10]">
        <img src={post.image} alt={post.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      </Link>
      <div className="mt-5 flex items-center gap-3 text-xs uppercase tracking-widest font-semibold text-greyish">
        <span className="text-aqua">{post.category}</span>
        <span className="w-1 h-1 rounded-full bg-border" />
        <span>{date}</span>
      </div>
      <Link to={`/blog/${post.slug}`}>
        <h3 className="mt-3 text-xl font-bold text-ink leading-snug group-hover:text-aqua transition-colors">{post.title}</h3>
      </Link>
      <p className="mt-2 text-greyish text-sm line-clamp-2">{post.excerpt}</p>
      <Link to={`/blog/${post.slug}`} className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-ink group-hover:text-aqua transition-colors">
        Read Article <ArrowUpRight className="w-4 h-4" />
      </Link>
    </motion.article>
  );
}
